import React from 'react'
import { Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Modal from 'react-modal'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import {
    TOAST_CHANGE_ERRROR,
    TOAST_CHANGE_SUCCESS,
} from '../../../redux/toast/types'
import { DeleteBoxIT } from './interface'
import { deleteBox } from '../../../services/boxes'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
}

const ModalContent = styled('div')`
    ${({ theme }) => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        background: ${theme.colors.white};
        border-radius:${theme?.spacing?.spc10};
        padding: ${theme?.spacing?.spc20};
    `}
`

const ModalMessage = styled('div')`
    ${({ theme }) => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: ${theme.colors.white};
        border-radius:${theme?.spacing?.spc10};
        margin-top:${theme?.spacing?.spc20};
        padding: ${theme?.spacing?.spc20};
    `}
`

const ModalTitle = styled('h3')`
    ${({ theme }) => `
        font-family: raleway;
        color: ${theme.colors.darkBlue};
        margin: 0;
    `}
`

const ModalActions = styled('div')`
    ${({ theme }) => `
        font-family: raleway;
        color: ${theme.colors.darkBlue};
        margin-top: {theme?.spacing?.spc20};
        flex-wrap: wrap;
    `}
`

const DeleteBox = ({ isOpen, setIsOpen, id, setRefreshKey }: DeleteBoxIT) => {
    // Hooks
    const dispatch = useDispatch()

    // Methods
    const afterOpenModal = () => {}

    const closeModal = () => {
        setIsOpen(false)
    }

    const handleDelete = (userId: string) => {
        deleteBox(userId)
            .then((resp: any) => {
                dispatch({
                    type: TOAST_CHANGE_SUCCESS,
                    message: '¡Box eliminado correctamente!',
                })
                setRefreshKey((refreshKey) => refreshKey + 1)
                closeModal()
            })
            .catch((err: any) => {
                dispatch({
                    type: TOAST_CHANGE_ERRROR,
                    message: 'Error al eliminar al Box',
                })
            })
    }

    return (
        <div>
            <Modal
                isOpen={isOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <ModalContent>
                    <ModalMessage>
                        <ModalTitle>
                            ¿Realmente le gustaría borrar a este box?
                        </ModalTitle>
                    </ModalMessage>
                    <ModalActions>
                        <Stack spacing={2} direction="row">
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => handleDelete(id)}
                            >
                                Borrar
                            </Button>
                            <Button variant="outlined" onClick={closeModal}>
                                Cancelar
                            </Button>
                        </Stack>
                    </ModalActions>
                </ModalContent>
            </Modal>
        </div>
    )
}

export default DeleteBox
